import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Item from "./Item";
import StoryView from "./StoryView";
import { useEffect, useState } from "react";
import ItemView from "./ItemView";
import miAxios from "../api/axios";
import { useAuth } from "../hooks/AuthProvider";
import Wait from "./Wait";

export default function Viewer(props) {
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [referencia, setReferencia] = useState("")
    const [descripcion, setDescripcion] = useState("")
    const [comentario, setcomentario] = useState("")
    const [precio, setPrecio] = useState("0.00")
    const [precioLista, setPrecioLista] = useState("0.00")
    const [url, setUrl] = useState("")

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(()=>{
        if (props.open){
            inicio()
        }
    }, [props.open])

    const inicio = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("items/view?tipo=" + props.tipo + "&cual=" + props.id)
            const data = response.data;
            if (data.respuesta == "S") {
                setReferencia(data.referencia)
                setDescripcion(data.descripcion)
                setcomentario(data.comentario)
                setPrecio(data.precio)
                setPrecioLista(data.precio_lista)
                setUrl(data.url)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return <Dialog open={props.open} fullWidth>
        <DialogContent>
            <Wait procesando={procesando} />
            {
                props.tipo == 1 && 
                    (<ItemView
                        descripcion={descripcion}
                        referencia={referencia}
                        comentario={comentario}
                        precio={precio}
                        precioLista={precioLista}
                        url={url}
                    />)
            }
            {
                props.tipo==2 && (
                    <StoryView 
                        url={url}
                    />
                )
            }
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="coopinfa" onClick={() => { props.cerrar() }}>Cerrar</Button>
        </DialogActions>
    </Dialog>
}